<template>
  <div>
    <sb-close-button></sb-close-button>

    <div class="widget_body">
      <div class="widget-header color-theme-default">
        <div class="widget-header-content">
          <div class="widget-header-title header-convo-list" :title="$t('conversations')">{{ $t("conversations") }}</div>

          <sb-setting></sb-setting>
        </div>

        <sb-account-profile></sb-account-profile>
      </div>

      <div class="list-conversation" :style="convoListStyle">

        <div class="list-conversationin" ref="convoList" @scroll="onScroll">

          <div v-if="!ready" class="list-conversation-loading">
            <div class="animated-background">
              <div class="background-masker activities-loading-head"></div>
              <div class="background-masker activities-loading-head-left"></div>
              <div class="background-masker activities-loading-head-right"></div>
              <div class="background-masker activities-loading-head-bottom"></div>
              <div class="background-masker sub-head-left"></div>
              <div class="background-masker sub-head-right"></div>
              <div class="background-masker sub-head-bottom"></div>

              <div class="background-masker space space1"></div>

              <div class="background-masker activities-loading-head head2"></div>
              <div class="background-masker activities-loading-head-left left2"></div>
              <div class="background-masker activities-loading-head-right right2"></div>
              <div class="background-masker activities-loading-head-bottom bottom2"></div>
              <div class="background-masker sub-head-left left-sub2"></div>
              <div class="background-masker sub-head-right right-sub2"></div>
              <div class="background-masker sub-head-bottom bottom-sub2"></div>

              <div class="background-masker space space2"></div>

              <div class="background-masker activities-loading-head head3"></div>
              <div class="background-masker activities-loading-head-left left3"></div>
              <div class="background-masker activities-loading-head-right right3"></div>
              <div class="background-masker activities-loading-head-bottom bottom3"></div>
              <div class="background-masker sub-head-left left-sub3"></div>
              <div class="background-masker sub-head-right right-sub3"></div>
              <div class="background-masker sub-head-bottom bottom-sub3"></div>

              <div class="background-masker space space3"></div>
            </div>
          </div>

          <ul v-else v-for="convo in convoList" :key="convo.id">
            <li @click="goToConvo(convo.id)">
              <a href="javascript:void(0)">

                <div v-if="convo.joinedAgents.length < 2" class="agent-avatar">
                  <div class="avatar"><img :src="convo.agentAvatar || defaultAvatar" alt=""></div>
                  <i class="agent-status away"></i>
                </div>

                <div v-else class="listconversation-avatar">
                  <div class="agent-joined">
                    <div class="avatar"><img :src="convo.joinedAgents[0].avatar_url || defaultAvatar" alt=""></div>
                    <div class="info"><p>{{ convo.joinedAgents[0].fullname }}</p></div>
                  </div>

                  <div v-if="getShowedAvatars(convo.joinedAgents) == 2" class="agent-joined">
                    <div class="avatar"><img :src="convo.joinedAgents[1].avatar_url || defaultAvatar" alt=""></div>
                    <div class="info"><p>{{ convo.joinedAgents[1].fullname }}</p></div>
                  </div>

                  <div v-if="convo.joinedAgents.length > 2" class="agent-joined">
                    <div class="avatar">
                      <img :src="defaultAvatar" alt="">
                      <div class="avatar-more-bg">
                        +{{ convo.joinedAgents.length - getShowedAvatars(convo.joinedAgents) }}
                      </div>
                    </div>
                    <div class="info">
                      <p v-for="(agent, index) in convo.joinedAgents" v-show="index >= getShowedAvatars(convo.joinedAgents)" :key="index">{{ agent.fullname }}</p>
                    </div>
                  </div>
                </div>

                <div class="content-summary">
                  <div v-if="convo.joinedAgents.length < 2" class="agent-name">{{ convo.agentName | capitalize }}</div>
                  <div v-else class="agent-name">{{ getJoinedAgentNames(convo.joinedAgents) | truncate(30, '...', ' ') }}</div>
                  <p>
                    <span class="yourmessage" v-if="convo.lastSenderType == 'user'">{{ $t('you') }}:</span>
                    {{ removeMarkdown(convo.lastMessage) }}
                  </p>
                </div>
                <div class="date-time">{{dateFormatTime(convo.time)}}</div>
                <div class="new-message-number" v-show="convo.countUnseenMessage > 0">{{ convo.countUnseenMessage }}</div>
              </a>
            </li>
          </ul>

        </div>

        <div :class="[loading ? 'visible' : 'invisible']" class="load-more"><i class="spinner"></i></div>

      </div>

      <div v-if="ready" class="list-conversation-bottom">
        <a @click="newConvo" href="javascript:void(0)" class="button color-theme-default add-new-conversation">
          <span class="icon-plus"></span> {{ $t("new_conversation") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Setting from '../components/Setting.vue'
import AccountProfile from '../components/AccountProfile.vue'
import CloseButton from '../components/CloseButton.vue'
import * as utils from '../utils'
import { mapGetters, mapState } from 'vuex'
import eventHub from '../lib/hub'
import { u as umbrella } from 'umbrellajs'
import store from '../store'
const objectPath = require('object-path')

export default {
  name: 'convo-list',

  components: {
    'sb-setting': Setting,
    'sb-account-profile': AccountProfile,
    'sb-close-button': CloseButton
  },

  data () {
    return {
      convoListStyle: {
        height: '100px',
        top: '100px'
      },

      bottom: false,

      loading: false
    }
  },

  computed: {
    ...mapState([
      'defaultAvatar',
      'convoEvents',
      'conversations',
      'agents',
      'account',
      'user',
      'accountId',
      'userId',
      'userReady',
      'cssReady',
      'languageReady',
      'settingReady',
      'convoListReady',
      'convoListEnd',
      'windowMode',
      'languageCode',
      'dateFormat'
    ]),

    ...mapGetters([
      'countUnseenMessageByConvoId'
    ]),

    convoList () {
      const _this = this

      const conversations = this.conversations || []
      let result = []

      utils.find(conversations, (convo) => {
        if (!convo.id) {
          return false
        }

        utils.log('convo', convo)

        const time = (new Date(utils.getMs(convo.last_actived) || utils.getMs(convo.created))).toISOString()

        const item = {
          id: convo.id,
          agentAvatar: '',
          agentName: '',
          joinedAgents: [],
          lastMessage: '',
          lastSenderType: '',
          time,
          countUnseenMessage: 0,
          created: convo.created,
          actived: convo.actived
        }

        const members = objectPath.get(convo, 'members', [])

        const events = objectPath.get(this.convoEvents, convo.id, [])

        events.forEach(event => {
          const text = objectPath.get(event, 'data.message.text', '')
          if (event.type === 'message_sent' && text !== '') {
            const byId = objectPath.get(event, 'by.id', '')
            const displayId = objectPath.get(event, 'by.display_id', '')
            item.lastMessage = text
            item.lastSenderType = _this.getSenderType(displayId || byId, members)
          } else if (event.type === 'conversation_joined' ) {
            const members = objectPath.get(event, 'data.conversation.members', [])
            const agents = utils.excludeBots(_this.getAgentsFromMembers(members))
            item.joinedAgents = utils.unionBy(item.joinedAgents, agents, 'id')

          }
        })

        item.joinedAgents.forEach(member => {
          if (member.type === 'agent') {
            const agent = utils.find(utils.excludeBots(_this.agents), v => v.id === member.id)
            if (agent) {
              item.agentName = agent.fullname
              item.agentAvatar = agent.avatar_url || ''
            }
          }
        })

        // if no joined agents
        if (!item.agentName) {
          const accountName = _this.account.name

          if (accountName) {
            item.agentName = accountName
          } else {
            const time = new Date(utils.getMs(convo.last_actived) || utils.getMs(convo.created))
            item.agentName = time
          }
        }

        item.countUnseenMessage = _this.countUnseenMessageByConvoId(convo.id)
        // utils.log('count Unseen Message', item.countUnseenMessage)

        result.push(item)
      })

      // utils.log('conversations', result)
      result = utils.orderBy(result, 'actived', 'desc')
      return result
    },

    ended () {
      return this.convoListEnd === true
    },

    ready () {
      utils.log('[convo list - ready] accountId', this.accountId)
      utils.log('[convo list - ready] userReady', this.userReady)
      utils.log('[convo list - ready] cssReady', this.cssReady)
      utils.log('[convo list - ready] languageReady', this.languageReady)
      utils.log('[convo list - ready] settingReady', this.settingReady)
      utils.log('[convo list - ready] convoListReady', this.convoListReady)

      return this.userReady &&
        this.cssReady &&
        this.languageReady &&
        this.settingReady &&
        this.convoListReady
    }
  },

  mounted () {
    utils.log('convo list mounted')

    this.resizeConvoListHeight()
    eventHub.$emit('widget.ui_changed', 'convolist280' )

    eventHub.childWindow.addEventListener('resize', this.resizeConvoListHeight, false)
  },

  beforeDestroy () {
    eventHub.childWindow.removeEventListener('resize', this.resizeConvoListHeight, false)
  },

  methods: {
    removeMarkdown (text) {
      return utils.removeMarkdown(text)
    },

    dateFormatTime (time) {
      return utils.showDateTime(time, store.state.dateFormat)
    },

    newConvo () {
      this.$router.push({ name: 'convo' })
    },

    goToConvo (id) {
      utils.log('goToConvo:', id)
      this.$router.push({ name: 'convo', params: { convoId: id } })
    },

    resizeConvoListHeight: utils.throttle(function () {
      utils.log('resize Convo List Height')

      const _this = this

      Vue.nextTick(() => {
        const header = umbrella('.widget-header', _this.$el)
        if (header.length < 1) return false

        let bottomHeight = 0
        const bottom = umbrella('.list-conversation-bottom', _this.$el)
        if (bottom.length > 0) {
          bottomHeight = bottom.size().height
        }

        const windowMode = _this.windowMode
        const headerHeight = header.size().height
        if (windowMode === 'mini') {
          const body = umbrella('.widget_body', _this.$el)
          if (body.length < 1) {
            return false
          }

          const bodyHeight = body.size().height

          _this.convoListStyle = {
            height: (bodyHeight - headerHeight - bottomHeight) + 'px',
            top: (headerHeight) + 'px'
          }
        } else { // full | mobile
          const windowHeight = eventHub.childWindow.innerHeight

          _this.convoListStyle = {
            height: (windowHeight - headerHeight - bottomHeight) + 'px',
            top: (headerHeight) + 'px'
          }
        }
      })
    }, 5),

    getSenderType (id, members) {
      const member = utils.find(members, item => item.id === id)
      if (member) return member.type

      const agent = utils.find(this.agents, item => item.id === id)
      if (agent) return 'agent'

      return 'system'
    },

    bottomVisible () {
      const convoList = umbrella(this.$refs.convoList)
      const scrollTop = this.$refs.convoList.scrollTop
      const height = convoList.size().height
      const scrollHeight = this.$refs.convoList.scrollHeight
      return scrollTop + height >= scrollHeight
    },

    onScroll: function () {
      this.bottom = this.bottomVisible()
    },

    async fetch () {
      utils.log('-----------------------------------------------------------')
      utils.log('fetch data')

      const accountId = this.account.id
      const userId = this.user.id

      await this.$store.dispatch('getConversations', { accountId, userId })
    },

    getAgent (id) {
      const agent = utils.find(this.agents, item => item.id === id)
      return agent || {}
    },

    getAgentsFromMembers (members = []) {
      const agents = []
      for (const member of members) {
        const agent = this.getAgent(member.member_id || member.id)
        if (agent.id) agents.push(agent)
      }
      return agents
    },

    getJoinedAgents (convo) {
      if (!convo || !convo.id) return []

      const agents = []
      for (const member of convo.members) {
        const agent = utils.find(this.agents, item => item.id === member.id)
        if (agent) {
          agents.push(agent)
        }
      }

      return agents
    },

    getShowedAvatars (joinedAgents) {
      if (joinedAgents.length === 3) return 1
      return 2
    },

    getJoinedAgentNames (joinedAgents) {
      let names = []
      joinedAgents.forEach(agent => names.push(agent.fullname))

      let name = names.join(', ')
      return name
    }
  },

  watch: {
    async bottom (bottom) {
      if (!bottom) return true

      utils.log('[convoList] bottom visible')

      if (this.ended) return true

      this.loading = true
      await this.fetch()
      this.loading = false
    },

    ready (ready) {
      utils.log('[convo list] ready changed', ready)
      if (!ready) return false

      utils.log('convo list ready')

      // no convo --> redirect to new convo
      if (this.conversations.length < 1) {
        this.$router.push({ name: 'convo' })
        return true
      }

      eventHub.$emit('widget.ui_changed', 'convolist446' )
      eventHub.$emit('widget.show_iframe')

      this.$nextTick(function () {
        this.resizeConvoListHeight()
      })
    }
  }
}
</script>
